export default __webpack_public_path__ + "static/media/words5.55447a90.png";